import { Avatar, Box, Button, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

const UserPosts = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };

        const res = await axios.get(`${apiBaseURL}/api/v1/admin/getallposts`, {
          headers,
          params: {
            page: paginationModel.page + 1,
            limit: paginationModel.pageSize
          }
        });

        const users = res?.data?.data || [];
        const meta = res?.data?.meta || {};

        const mappedRows = users.map((user) => ({
          id: user.userId,
          userId: user.userId,
          fullName: user.fullName,
          profileImage: user.profileImage,
          postCount: user.postCount
        }));

        setRows(mappedRows);
        setTotalRows(typeof meta.total === "number" ? meta.total : mappedRows.length);
      } catch (error) {
        console.error("Error fetching posts:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch posts. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [paginationModel.page, paginationModel.pageSize]);

  const columns = useMemo(
    () => [
      {
        field: "user",
        headerName: "User",
        flex: 1.5,
        minWidth: 240,
        sortable: false,
        renderCell: (params) => (
          <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{ cursor: "default" }}
          >
            <Avatar
              src={params.row.profileImage || ""}
              alt={params.row.fullName || "User"}
              sx={{ width: 34, height: 34 }}
            />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {params.row.fullName || "N/A"}
            </Typography>
          </Box>
        )
      },
      {
        field: "postCount",
        headerName: "Posts",
        flex: 0.5,
        minWidth: 120,
        sortable: false
      },
      {
        field: "actions",
        headerName: "Actions",
        flex: 0.7,
        minWidth: 140,
        sortable: false,
        renderCell: (params) => (
          <Button
            style={{ textTransform: "none" }}
            onClick={() => {
              if (params.row.userId) {
                navigate(`/user-posts/detail`, {
                  state: { userId: params.row.userId, userName: params.row.fullName }
                });
              }
            }}
          >
            View Posts
          </Button>
        )
      }
    ],
    []
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ height: 675, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowSelectionModel={[]}
          onRowSelectionModelChange={() => {}}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          localeText={{ noRowsLabel: "No Posts available" }}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none !important"
            },
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
        />
      </Box>
    </DashboardLayout>
  );
};

export default UserPosts;
